import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AnalyticsService, ApplicationInsightsService } from '@crosscutting/public_api';

import { VMDataService, VeiligheidsMeterService } from '../../../vm_api';
import { VeiligheidsMeter, VMModule, VMTip, VMVraag } from '../../../vm_models';
import { ContentHelper } from '../../../services/helpers/content-helper';
import { VMContentId } from 'projects/cybercheck/src/models/vmmodule';
import { last } from 'lodash';

@Component({
  selector: 'app-check',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CheckComponent implements OnInit {
  @Input() questionsReady;
  @Input() currentVMModuleStatus;

  veiligheidsMeter: VeiligheidsMeter;
  currentVMModule: VMModule;
  currentVMTips: VMTip[];
  pageTitle = '[not set]';
  tipsContent = '[not set]';
  pageContentCheck = '[not set]';
  tipsTitle = '[not set]';
  tipLinkText = '[not set]';
  tipLinkAria = '[not set]';
  nextTitle = '[not set]';
  nextOverzicht = '[not set]';
  multipleChoiceText = '[not set]';
  singleChoiceText = '[not set]';
  vraagSupTitle = '[not set]';
  progressTextDone = '[not set]';
  vmReady = false;
  paza = document.body.dataset.paza || '';
  pagename = document.body.dataset.pagename || '';
  badgeAltText = '[not set]';
  private reinit = false;
  pageinfo = 'Beantwoord onderstaande vragen'

  constructor(
    private _vmDataService: VMDataService,
    private _analyticsService: AnalyticsService,
    private _applicationInsightsService: ApplicationInsightsService,
    private _router: Router,
    private veiligheidsMeterService: VeiligheidsMeterService,
  ) { }
  
  ngOnInit() {
    this.veiligheidsMeter = this._vmDataService.getVeiligheidsMeter();

    if (this.isReady) {
      this.setCurrentModule(this.veiligheidsMeter.currentVMModule);
      if (this.totalQuestions == 0) {
        console.error('Empty module: ', this.veiligheidsMeter.currentVMModule);
        this._router.navigate(['/error']);
      }
      this.setTips();
      this.setPageContent();
      this.initAnalytics('/check',2000);
    } else {
      this._router.navigate(['/intro']);
    }
  }

  /* retrieve array of questions to be shown */
  public get actualQuestions() {
    let vragen: VMVraag[] = [],
        previousQuestionAnswered = false;
    
    this.questionsReady = 'start';

    if (this.currentVMModule?.vragen?.length > 0) {
      for (var index = 0; index < this.currentVMModule.vragen.length; index++) {
        /* always show first question */
        if (index == 0) {
          vragen.push(this.currentVMModule.vragen[index]);
        }

        /* show if previous question was answered */
        if (previousQuestionAnswered) {
          vragen.push(this.currentVMModule.vragen[index]);
          this.questionsReady = 'next';
        } 

        if (vragen[index].antwoorden.find(x => x.checked)) {
          if (index == this.currentVMModule.vragen.length - 1) {
            this.questionsReady = "done";
          }
          previousQuestionAnswered = true;
        } else {
          previousQuestionAnswered = false;
          break;
        }    
      }
    } 
    return vragen;
  }

  /* show save button? */
  public get showFinal() {
    if (this.actualQuestions.length==this.totalQuestions && 
        this.totalQuestions > 0 && 
        this.currentVMModule.status == '') {
      let finalQuestion = this.currentVMModule.vragen[this.totalQuestions - 1];

      if (finalQuestion.antwoorden.find(x => x['checked'])) {
        if (!this.reinit) {
          this.initAnalytics('/check', 1000);
        }
        this.reinit = true;
        return true;
      }
    }
    this.reinit = false;

    return false;
  }

  /* count questions total */
  public get totalQuestions() {
    let result = 0;
    if (this.currentVMModule.vragen) {
      result = this.currentVMModule.vragen.length;
    }
    return result;
  }

  public get isReady():boolean {
    return this.veiligheidsMeter && this.veiligheidsMeter.currentVMModule?.length > 0;
  }

  /* action button clicked */
  actionClicked() {
    let selectedAnswers = [];

    this.currentVMModule.vragen.forEach((vraag) => {
      vraag.antwoorden.forEach((antwoord) => {
        if(antwoord.checked) {
          selectedAnswers.push({ "id": antwoord.id, "geselecteerd": "true" });
        }
      })
    });

    this.veiligheidsMeterService.sendFinishedModule(this.veiligheidsMeter.vmID, this.currentVMModule.id, selectedAnswers)
      .subscribe(vmStoreResponse => {
        this.veiligheidsMeter.vmID = vmStoreResponse.veiligheidsmeter.id;
        this.veiligheidsMeterService.getModuleResults(this.veiligheidsMeter.vmID, this.veiligheidsMeter.currentVMModule)
          .subscribe(vmResultResponse => {
            this.currentVMModule.status = vmResultResponse.module.badge

            if (!this.currentVMModule.tips) {
              this.currentVMModule.tips = new Array<VMTip>;
            }
            
            let topTips = new Array<VMContentId>, 
            highPrioTips = vmResultResponse.module.nietOpOrde || [],
            mediumPrioTips = vmResultResponse.module.opOrde || [],
            lowPrioTips = vmResultResponse.module.nietGeselecteerd || [];

            topTips = highPrioTips.concat(mediumPrioTips.concat(lowPrioTips));
            topTips = topTips.slice(0,3);
            topTips.forEach((ci) => {
              let tipContent = this.veiligheidsMeter.vmContentItems.find(x => x.id === ci.contentId);
            
              if (this.currentVMModule.tips.findIndex( x => x.id == ci.contentId) == -1) {                  
                  if (this.veiligheidsMeter.vmContentItems.findIndex((x) => x.id == ci.contentId) > -1 ) {
                    let tip = new VMTip;

                    tip.id = ci.contentId;
                    tip.content = tipContent;
                    this.currentVMModule.tips.push(tip);
                  } else {
                    console.error('no content item found for: ', ci.contentId);
                  }
                }
              });
              
            this._vmDataService.saveVeiligheidsMeter(this.veiligheidsMeter);
            this.setPageContentBadge();
            this.setTips();
            this.currentVMModuleStatus = this.currentVMModule.status;

            window.scrollTo({top: 0, behavior: "smooth"});

            let path = '/' + ContentHelper.getName() + '/check';
            
            this._analyticsService.googleEmitPageview(path);
            this._applicationInsightsService.logPageView(null, path);
          }, () => {
            console.error('Error while getting results');
          });
      }, () => {
        console.error('Error while storing answers');
      });
  }
  
  /* checkbox option changed */
  checkValue(questionId, answerId, counter) {
    let vraag = this.currentVMModule.vragen.find(x => x.id == questionId),
        antwoord = vraag.antwoorden.find(x => x.id === answerId),
        lastQuestion = this.currentVMModule?.vragen[this.currentVMModule?.vragen.length-1],
        count = counter + 1;

    if (!antwoord.checked) {
      antwoord.checked = true;
    } else {
      antwoord.checked = undefined;
    }

    if (vraag.antwoorden.find(x => x.checked)) {
      if (vraag.id == lastQuestion.id || 
        lastQuestion.antwoorden.find(x => x.checked)) {
        this.pageinfo='De vragenlijst is compleet';
      } else {
        this.pageinfo='Vraag ' + count + ' is beschikbaar';
      }
    } else {
      this.pageinfo='Beantwoord de laatste vraag';
    }
    this._vmDataService.saveVeiligheidsMeter(this.veiligheidsMeter);
  }

  /* radio option changed */
  checkValueRadio(questionId, answerId, counter) {
    let vraag = this.currentVMModule.vragen.find(x => x.id == questionId),
        antwoord = vraag.antwoorden.find(x => x.id == answerId),
        lastQuestion = this.currentVMModule?.vragen[this.currentVMModule?.vragen.length-1],
        count = counter + 1;

    if (!antwoord.checked) {
      let checked = vraag.antwoorden.find(x => x.checked);

      if(checked) {
        checked.checked = undefined;
      }
      /* set checked */
      if (vraag.id == lastQuestion?.id || 
          lastQuestion.antwoorden.find(x => x.checked)
      ) {
        this.pageinfo='De vragenlijst is compleet';
      } else {
        this.pageinfo='Vraag ' + count + ' is beschikbaar';
      }
      antwoord.checked = true;
      this._vmDataService.saveVeiligheidsMeter(this.veiligheidsMeter);
    }
  }

  /* (re)init analytics */
  initAnalytics(page, timeout: number) {
    setTimeout(() => {
      this._analyticsService.celebrusReinit();
      this._applicationInsightsService.logPageView(null, page);
    }, timeout);
  }
  
  /* helper: get module based on unique key value */
  getModule(key) {
    let index: number;

    index = this.veiligheidsMeter.vmModules.findIndex(x => x.key === key);

    return this.veiligheidsMeter.vmModules[index];
  }

  /* back to intro */ 
  goToOverzicht() {
    this._router.navigate(['/intro']);
  }

  /* Show tips-page with selected ID */
  goToTip(id) {
    setTimeout(() => {
      this.veiligheidsMeter.currentVMTip = id;
      this._vmDataService.saveVeiligheidsMeter(this.veiligheidsMeter);
      this._router.navigate(['/tips']);
    });
  }

  setBadgeAlt(status) {
    let badgeCI = ContentHelper.getBadgeAlt(),
        contentItem = this.veiligheidsMeter.vmContentItems.find(x => x.id === badgeCI).content;

    return JSON.parse(contentItem)[status];
  }

  /* set the selected module as current module*/
  setCurrentModule(id) {
    this.currentVMModule = this.getModule(id)

    if (this.currentVMModule.status == '') {
      this.currentVMModuleStatus = 'open';
    }
  }

  /* Set the page content */
  setPageContent() {
    let content = ContentHelper.getContent('check');

    Object.keys(content).forEach((key) => {
      let item = Object.keys(content[key])[0];

      if (this[key]) {
        let contentItem;
        
        try { 
          contentItem = this.veiligheidsMeter.vmContentItems.find(x => x.id === content[key][item])[item];
          this[key] = contentItem;
        } catch {} 
      } else {
        console.error(key, ' key not found on component');
      }
    });

    this.setPageContentBadge();
  }

  /* depending on the score, change title and content */
  setPageContentBadge() {
    try {
      let badgeIds = JSON.parse(this.veiligheidsMeter.vmContentItems.find(x => x.id === ContentHelper.getBadge()).content)[this.currentVMModule.key].split(',');

      let index = this.currentVMModule.status.slice(-1);

      if (index && Number.parseInt(index)) {
        this.setTitleAndContent(badgeIds[Number.parseInt(index) - 1]);
      }

      this.badgeAltText = this.setBadgeAlt(this.currentVMModule.status);

      this.initAnalytics('/score', 1000);

    } catch {
      console.error('badgeIds not properly configured.');
    }
  }

  /* get tips if module is complete
  */
  setTips() {
    if (this.currentVMModule.tips) {
      this.currentVMTips = this.currentVMModule.tips;
      this.pageinfo = 'De resultaten zijn bekend';
    }

  }

  /* Change title and content to requested ID */
  setTitleAndContent(id) {
    try {
      let title = this.veiligheidsMeter.vmContentItems.find(x => x.id === id).title,
          content = this.veiligheidsMeter.vmContentItems.find(x => x.id === id).content;

      if (title) {
        this.pageTitle = title;
      }
      if (content) {
        this.tipsContent = content;
      }
    } catch {
      console.error('No content for: ', id);
    }    
  }
}
